import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest, HttpResponse, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError, of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { CommonService } from './common.service';
import { DataService } from './data.service';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Injectable(//{providedIn: 'root')
)
export class RequestIntercepterService implements HttpInterceptor {

  constructor(private commonService: CommonService, private router: Router, private dataService: DataService, private tokenExtractor: HttpXsrfTokenExtractor, private dialog: MatDialog,private memorystore: MemoryStorageService) { }
  //constructor(private commonService: CommonService, private router: Router, private dataService: DataService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.commonService.showHideLoader(true);

    // let token = this.tokenExtractor.getToken();
    // if (token !== null) {
    //   request = request.clone({ setHeaders: { "X-XSRF-TOKEN": token } });
    // }
    if (request.url.indexOf(this.dataService.piicheckurl) == -1 || this.dataService.piicheckurl ==""){
      // if (this.commonService.getUserInfoFromLocalStorage("logonLogoffDetailsId") != undefined && this.commonService.getUserInfoFromLocalStorage("logonLogoffDetailsId") != '') {
      //   request = request.clone({ setHeaders: { "logonLogoffDetailsId": this.commonService.getUserInfoFromLocalStorage("logonLogoffDetailsId") } });
      // }
      if (this.memorystore.getItem("logonLogoffDetailsId") != undefined && this.memorystore.getItem("logonLogoffDetailsId") != '') {
        request = request.clone({ setHeaders: { "logonLogoffDetailsId": this.memorystore.getItem("logonLogoffDetailsId") } });
      }
    }    
    if (this.dataService.is_middleware_required == true) {

      if (request.url.indexOf(this.dataService.apiURL_Core) != -1 ||
        (this.dataService.apiURL_Authentication != "" && this.dataService.apiURL_Authentication != undefined
          && request.url.indexOf(this.dataService.apiURL_Authentication) != -1)) {

        var api_type = (request.url.indexOf(this.dataService.apiURL_Authentication != "" && this.dataService.apiURL_Authentication != undefined && this.dataService.apiURL_Authentication) != -1) ? "auth" : "workflow";
        var apiMethodName = '';
        var body = {};

        if (api_type == 'auth')
          apiMethodName = request.url.replace(this.dataService.apiURL_Authentication, "");
        // else if(api_type == 'auth')
        //   apiMethodName = request.url.replace(this.dataService.apiURL_Core, "");

        else
          apiMethodName = request.url.replace(this.dataService.apiURL_Core, "");

        if (request.method.toLowerCase() == "get") {
          // var arrparam = request.params.toString().split("&");
          // arrparam.forEach(param => {
          //   var kv = param.split("=");
          //   body[kv[0]] = kv[1];
          // })

          const paramsArray = request.params.keys().map(x => ({ [x]: request.params.get(x) }));
          paramsArray.forEach(item => {
            Object.keys(item).forEach(x => {
              body[x] = item[x];
            });
          });

        }
        else {
          body = request.body;
        }

        var requestData = {};
        requestData["HTTP_Method"] = request.method;
        requestData["API_Method"] = apiMethodName;
        requestData["API_Type"] = api_type;
        requestData["Request_Body"] = body;

        request = request.clone({
          headers: request.headers.set('Content-Type', 'application/json')
        });

        request = request.clone({
          url: this.dataService.middleware_url, method: "post", params: new HttpParams(), withCredentials: true
        });

        request = request.clone({
          body: requestData
        });
      }
    }

    //Add Token into request header
    // if (localStorage.length > 0 && localStorage.getItem("token") != 'undefined') {
    //   request = request.clone({
    //     setHeaders: {
    //       token: `${localStorage.getItem("token")}`
    //     }
    //   });
    // }

    // // Add PWM User Id in request header
    // if (localStorage.length > 0 && localStorage.getItem("userId") != null) {
    //   request = request.clone({
    //     setHeaders: {
    //       userId: localStorage.getItem("userId")
    //     }
    //   });
    // }
    return next.handle(request).pipe(map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if (event.body != null || event.body != undefined) {
          let res;
          if (typeof event.body === 'object')
            res = JSON.parse(JSON.stringify(event.body));
          else
            res = JSON.parse(event.body);

          if (res.status == true && res.data == 'session_killed') {
            const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {
              disableClose: true,
              data: {
                title: "Login",
                messageBoxType: 'ok',
                icon: '',
                message: 'Your session has been terminated.<br>You have been redirected to login page.'
              }
            });
            dialogRef1.afterClosed().subscribe((confirmed: boolean) => {
              if (confirmed) {
                if (this.dataService.is_sso == true) {
                  //this.router.navigate(['/sso-logout']);
                  let url = this.dataService.sso_url;
                  window.location.href = url;
                } else {
                  this.router.navigate(["login"]);
                }
              } else {
                if (this.dataService.is_sso == true) {
                  //this.router.navigate(['/sso-logout']);
                  let url = this.dataService.sso_url;
                  window.location.href = url;
                } else {
                  this.router.navigate(["login"]);
                }
              }
            })
            // this.commonService.showMessageBox("Your session has been terminated.<br>You have been redirected to login page.", "Login", "error");
            // this.commonService.showHideLoader(false);
            // this.router.navigate(["login"]);
          }
        }
      }
      return event;
    }),
      catchError(err => {
        if (err.status === 400 || err.status === 401 || err.status === 403 || err.status === 404 || err.status === 405 || err.status === 500) {
          //logout session

          this.commonService.showHideLoader(false);

          this.router.navigate(["error"]);
        }
        return throwError(err);
      }),
      finalize(() => {
        //  if (!request.url.match('controlpanel') && !request.url.match('MyIdeas')) {
        this.commonService.showHideLoader(false);
        //  }
      })
    );

    // return next.handle(request).pipe(
    //   catchError(err => {
    //     if (err.status === 400 || err.status === 401 || err.status === 403 || err.status === 404 || err.status === 405 || err.status === 500) {
    //       //logout session

    //       this.commonService.showHideLoader(false);
    //       this.router.navigate(["error"]);
    //     }
    //     return throwError(err);
    //   }),
    //   finalize(() => {
    //     this.commonService.showHideLoader(false);
    //   })
    // );

  }
}

